var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"ods-aside",style:({ width: _vm.width }),attrs:{"data-name":"OdsAside"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }